export default __webpack_public_path__ + "static/media/chatbot.c290542a.svg";